/*
 * GroupProductsApp - forms most of the main part of a Group page,
 * displaying the products in any of several formats.
 *
 * Receives groupItems = { itemApplications, products, productDetail }
 * from Redux.
 */
import React from 'react';
import PropTypes from 'prop-types';
import _, {pick} from 'lodash';

import {connect, Provider} from 'react-redux';

import GroupProductsContainer from "./GroupProductsContainer";
import {getReduxStore} from "../../ReduxStore/store";
import {CartConfigContext} from "../../contexts/CartConfigContext";

function mapStateToProps(state) {
  let {vehicleSlice = {}, groupItemsSlice = {}, scrapyardSlice={}, cart} = state;

  let out =  Object.assign(
    pick(cart, 'shoppingCart', 'dynamicCart'),
    pick(scrapyardSlice, 'currentAgent'),
    vehicleSlice, groupItemsSlice);

  // console.log("MAP STATE:" , out);
  return out;
}

const GroupProductsWrapper = connect(mapStateToProps)(GroupProductsContainer);

/*
 * The main part of a group page - the Products Section.
 *
 */
export default function GroupProductsApp({cartConfig, ...props}) {
  // static props from product_groups/show.html:
  // cartConfig, cartCode, groupId, productGroup, pageConfig, groupProperties

  // 2026-06 - cartConfig is camelCase
  return <Provider store={getReduxStore()}>
    <CartConfigContext.Provider value={cartConfig}>
      <GroupProductsWrapper {...props} />
    </CartConfigContext.Provider>
  </Provider>
}

GroupProductsApp.propTypes = {
  // These props come from the Rails template.
  id: PropTypes.string, // optional, GroupProductsContainer will provide
  groupId: PropTypes.number.isRequired,
  groupProperties: PropTypes.object.isRequired
  // 2021-10 these are the only props we have
}
